<div *ngIf="!isLoading; else spinner">
  <h1 mat-dialog-title xmlns="http://www.w3.org/1999/html">
    <ng-container *ngIf="runway > 0; else addTitle">Edit Runway</ng-container>
  </h1>
  <mat-dialog-content [formGroup]="formGroup">
    <div class="form-container">
      <fieldset class="fieldset-container">
        <legend>Runway Information</legend>
        <p>
          <mat-form-field class="edit-runway">
            <input matInput
                   placeholder="Runway Name *"
                   formControlName="name"
                   [(ngModel)]="runway.name">
          </mat-form-field>
          <mat-form-field class="edit-runway">
            <input matInput
                   placeholder="Runway Length (ft)*"
                   formControlName="length"
                   [(ngModel)]="runway.length">
          </mat-form-field>
          <mat-form-field class="edit-runway">
            <input matInput
                   placeholder="Runway Width (ft)*"
                   formControlName="width"
                   [(ngModel)]="runway.width">
          </mat-form-field>
          <mat-form-field class="edit-runway">
            <input matInput
                   placeholder="PCN"
                   formControlName="pcn"
                   [(ngModel)]="runway.pcn">
          </mat-form-field>
        </p>
        <p>
          <mat-form-field class="edit-runway">
            <mat-select placeholder="Type" [(value)]="selectedRunwayType" name="type" formControlName="type">
              <mat-option value="Runway">Runway</mat-option>
              <mat-option value="Waterway">Waterway</mat-option>
              <mat-option value="Helipad">Helipad</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="edit-runway">
            <input matInput
                   placeholder="Tire Pressure"
                   formControlName="tirePressure"
                   [(ngModel)]="runway.tirePressure">
          </mat-form-field>
          <mat-form-field class="edit-runway">
            <input matInput
                   placeholder="Material Type *"
                   formControlName="materialType1"
                   [(ngModel)]="runway.materialType1">
          </mat-form-field>
          <mat-form-field class="edit-runway">
            <input matInput
                   placeholder="Add'l Material Type"
                   formControlName="materialType2"
                   [(ngModel)]="runway.materialType2">
          </mat-form-field>
        </p>
        <p>
          <mat-form-field class="edit-runway">
            <input matInput
                   placeholder="Treatment"
                   formControlName="treatment"
                   [(ngModel)]="runway.treatment">
          </mat-form-field>
          <mat-form-field class="edit-runway">
            <mat-select placeholder="Condition *" [(value)]="selectedCondition" name="condition"
                        formControlName="condition">
              <mat-option value="Failed">Failed</mat-option>
              <mat-option value="Poor">Poor</mat-option>
              <mat-option value="Fair">Fair</mat-option>
              <mat-option value="Good">Good</mat-option>
              <mat-option value="Excellent">Excellent</mat-option>
              <mat-option value="Not Reported">Not Reported</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="edit-runway">
            <mat-select placeholder="Pavement Type" [(value)]="selectedPavementType" name="pavementType"
                        formControlName="pavementType">
              <mat-option value="Rigid">Rigid</mat-option>
              <mat-option value="Flexible">Flexible</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="edit-runway">
            <input matInput
                   placeholder="Subgrade Strength"
                   formControlName="subgradeStrength"
                   [(ngModel)]="runway.subgradeStrength">
          </mat-form-field>
        </p>
        <p>
          <mat-form-field class="edit-runway">
            <mat-select placeholder="Edge Lighting" [(value)]="selectedEdgeLighting" name="edgeLighting"
                        formControlName="edgeLighting">
              <mat-option value="High">High</mat-option>
              <mat-option value="Low">Low</mat-option>
              <mat-option value="Strobe">Strobe</mat-option>
              <mat-option value="Medium">Medium</mat-option>
              <mat-option value="Flood">Flood</mat-option>
              <mat-option value="Perimeter">Perimeter</mat-option>
              <mat-option value="Non Standard">Non Standard</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="edit-runway">
            <input matInput
                   placeholder="Wt Bearing 1 Wheel"
                   formControlName="wtBearing1Wheel"
                   [(ngModel)]="runway.wtBearing1Wheel">
          </mat-form-field>
          <mat-form-field class="edit-runway">
            <input matInput
                   placeholder="Wt Bearing 2 Wheel"
                   formControlName="wtBearing2Wheel"
                   [(ngModel)]="runway.wtBearing2Wheel">
          </mat-form-field>
          <mat-form-field class="edit-runway">
            <input matInput
                   placeholder="Wt Bearing 2 Wheel Tandem"
                   formControlName="wtBearing2WheelTandem"
                   [(ngModel)]="runway.wtBearing2WheelTandem">
          </mat-form-field>
        </p>
        <p>
          <mat-form-field class="edit-runway">
            <input matInput
                   placeholder="Wt Bearing 2 Wheel Dbl Tandem"
                   formControlName="wtBearing2WheelDblTandem"
                   [(ngModel)]="runway.wtBearing2WheelDblTandem">
          </mat-form-field>
        </p>
      </fieldset>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button type="submit" [disabled]="!formGroup.valid" class="mat-raised-button submit-button" (click)="save()">
      Save
    </button>
    <button id="cancelButton" class="mat-raised-button" (click)="cancel()">Cancel</button>
  </mat-dialog-actions>
</div>
<ng-template id="spinnerContainer" #spinner>
  <mat-dialog-content>
    <mat-spinner id="spinner" [diameter]="100" [color]="'accent'"></mat-spinner>
  </mat-dialog-content>
</ng-template>
<ng-template #addTitle>
  Add Runway
</ng-template>
